<template>
    <!-- {{ dataList [0]}} -->
    <div class="field">
        <!-- <MultiSelectDropdown label="Issue Id" v-model="ObjServiceType.issueid" :items="options.issueidarray"
            @update:modelValue="" /> -->
        <TextInput v-model="ObjServiceType.issueid" placeholder=" " :requiredIcon="false" clearable name="Issue Id"
            id="Issue Id" label="Issue Id" :rules="{ required: false }" />
    </div>
    <div class="field">
        <!-- <MultiSelectDropdown label="Request Id" v-model="ObjServiceType.requestid" :items="options.requestidarray"
            @update:modelValue="" /> -->
        <TextInput v-model="ObjServiceType.requestid" placeholder=" " :requiredIcon="false" clearable name="Request Id"
            id="Request Id" label="Request Id" :rules="{ required: false }" />
    </div>
    <div class="field">
        <MultiSelectDropdown label="To Storename" v-model="ObjServiceType.tostore" :items="options.tostorearray"
            @update:modelValue="updatedSupplier" />
    </div>
    <div v-if="issuesstatus==2" class="field">
        <!-- {{ options.issuearray }} -->
        <MultiSelectDropdown label="Issued By" v-model="ObjServiceType.issuedby" :items="options.issuearray"
            @update:modelValue="updatedissueby" />
    </div>
    <div v-if="issuesstatus==1" class="field">
        <MultiSelectDropdown label="Received By" v-model="ObjServiceType.recby" :items="options.recbyarray"
            @update:modelValue="updatedrecby" />
    </div>
    <div v-if="issuesstatus == 1" class="field">
        <MultiSelectDropdown label="Request By" v-model="ObjServiceType.reqby" :items="options.reqbyarray"
            @update:modelValue="updatedreqby" />
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from 'vue'
import MultiSelectDropdown from "../../../../components/FormComponents/MultiSelectDropdown.vue";
import TextInput from "../../../../components/FormComponents/TextInput.vue";
import StoreService from "../../../../modules/Inventory/Service/StoreService";
import { useRoute, useRouter } from "vue-router";

export default defineComponent({
    components: {
        MultiSelectDropdown,
        TextInput,
    },

    props: {
        removechiptype: {
            type: Number,
            default: 0
        },
        issuesstatus: {
            type: Number,
            default: 0
        },
         dataList: {
            type: Array,
            default: []
        }
    },

    setup(props, { emit }) {
        const router = useRouter();
        const route = useRoute();

        let SessionUserData = localStorage.getItem("UsersData");
        let usersData;
        if (SessionUserData !== null) {
            usersData = JSON.parse(SessionUserData);
        }
        onMounted(() => {
            Loadstores()
            let SessionUserData = localStorage.getItem("UsersData");
            if (SessionUserData !== null) {
                usersData = JSON.parse(SessionUserData);
            }

            const uniqueItems = [...new Map(props.dataList.map((item:any) => [item['IssuedBy'], item])).values()];
            options.value.issuearray = uniqueItems.map(item => ({
                name: item['IssuedByName'], // Display name in the dropdown

                value: item['IssuedBy'] // Unique identifier (or another unique value)
            }));


            const uniqueItems2 = [...new Map(props.dataList.map((item:any) => [item['ReceivedBy'], item])).values()];
            options.value.recbyarray = uniqueItems2.map(item => ({
                name: item['ReceivedByName'], // Display name in the dropdown
                value: item['ReceivedBy'] // Unique identifier (or another unique value)
            }));

            const uniqueItems3 = [...new Map(props.dataList.map((item:any) => [item['RequestedBy'], item])).values()];
            options.value.reqbyarray = uniqueItems3.map(item => ({
                name: item['RequestedByName'], // Display name in the dropdown
                value: item['RequestedBy'] // Unique identifier (or another unique value)
            }));

        })

        let StoreID = route.query.Id
        const ObjServiceType = ref({
            issueid: ref(),
            requestid: ref(),
            tostore: ref(),
            issuedby: ref(),
            recby: ref(),
            reqby: ref()

        });
        let options: any = ref({
            tostorearray: [],
            recbyarray: [],
            re1byarray: [],

            issuearray: [],

        })
        let ToStoreNames = ref('');
        let ToStoreIds = ref('');
        let issuebyIds = ref('');
        let issuebyNames = ref('');

        let reqbyNames = ref('');
        let reqbyIds = ref('');
        let recbyIds = ref('');

        let recbyNames = ref('');



        watch(
            () => ObjServiceType.value.tostore,
            (newVal) => {
                emit("tostorename", ToStoreNames.value);
                emit("tostoreid", ToStoreIds.value);
            }
        );

        watch(
            () => ObjServiceType.value.issueid,
            (newVal) => {
                emit("updatedissuecode", ObjServiceType.value.issueid);
            }
        );


        watch(
            () => ObjServiceType.value.requestid,
            (newVal) => {
                emit("updatedrequestcode", ObjServiceType.value.requestid);
            }
        );
          watch(
            () => ObjServiceType.value.issuedby,
            (newVal) => {
                emit("toissuename", issuebyNames.value);

                emit("updatedissuedby", ObjServiceType.value.issuedby);
            }
        );
        watch(
            () => ObjServiceType.value.recby,
            (newVal) => {

                emit("recname", recbyNames.value);
                // alert(ObjServiceType.value.recby)
                emit("updatedrecby", ObjServiceType.value.recby);
            }
        );
        watch(
            () => ObjServiceType.value.reqby,
            (newVal) => {
                emit("reqname", reqbyNames.value);

                emit("updatedreqby", ObjServiceType.value.reqby);
                // alert(ObjServiceType.value.reqby)
            }
        );

        const Loadstores = async () => {
            const response = await StoreService.getStoreByStoreId(StoreID, usersData.OrganizationId,
                usersData.BranchId);
            console.log(response);
            options.value.tostorearray = response["result"].map((item) => {
                item.name = item.Name;
                item.value = item.StoreId;
                return item;
            });
        }

        function updatedSupplier() {
            debugger;
            ToStoreIds.value = '';
            const selectedValues = ObjServiceType.value.tostore;

            if (selectedValues && Array.isArray(selectedValues)) {
                const selectedNames: any = [];
                const selectedIds: any = []
                selectedValues.forEach((selectedValue) => {
                    const selectedOption = options.value.tostorearray.find(
                        (option) => option.value === selectedValue
                    );
                    const selectedIdOption = options.value.tostorearray.find(
                        (option) => option.value === selectedValue
                    );
                    if (selectedOption) {
                        const selectedName = selectedOption.Name;
                        selectedNames.push(selectedName);
                    }
                    if (selectedIdOption) {
                        const selectedName = selectedOption.StoreId;
                        selectedIds.push(selectedName);
                    }
                });
                console.log("Selected Names:", selectedNames.join(", "));
                if (selectedNames.length > 2) {
                    ToStoreNames.value = selectedNames.slice(0, 2).join(", ") + ", ...";
                } else {
                    ToStoreNames.value = selectedNames.join(", ");
                }
                if (selectedIds.length > 0) {
                    ToStoreIds.value = selectedIds.join(", ");
                }
                console.log(ToStoreIds.value);

            }
        }

        //issues
        function updatedissueby() {
            debugger;
            issuebyIds.value = '';
            const selectedValues = ObjServiceType.value.issuedby;

            if (selectedValues && Array.isArray(selectedValues)) {
                const selectedNames: any = [];
                const selectedIds: any = []
                selectedValues.forEach((selectedValue) => {
                    const selectedOption = options.value.issuearray.find(
                        (option) => option.value === selectedValue
                    );
                    const selectedIdOption = options.value.issuearray.find(
                        (option) => option.value === selectedValue
                    );
                    if (selectedOption) {
                        const selectedName = selectedOption.IssuedByName;
                        selectedNames.push(selectedName);
                    }
                    if (selectedIdOption) {
                        const selectedName = selectedOption.IssuedBy;
                        selectedIds.push(selectedName);
                    }
                });
                console.log("Selected Names:", selectedNames.join(", "));
                if (selectedNames.length > 2) {
                    issuebyNames.value = selectedNames.slice(0, 2).join(", ") + ", ...";
                } else {
                    issuebyNames.value = selectedNames.join(", ");
                }
                if (selectedIds.length > 0) {
                    issuebyIds.value = selectedIds.join(", ");
                }
                // alert(issuebyNames.value)
                console.log(ToStoreIds.value);

            }
        }
//
        function updatedreqby() {
            debugger;
            reqbyIds.value = '';
            const selectedValues = ObjServiceType.value.reqby;

            if (selectedValues && Array.isArray(selectedValues)) {
                const selectedNames: any = [];
                const selectedIds: any = []
                selectedValues.forEach((selectedValue) => {
                    const selectedOption = options.value.reqbyarray.find(
                        (option) => option.value === selectedValue
                    );
                    const selectedIdOption = options.value.reqbyarray.find(
                        (option) => option.value === selectedValue
                    );
                    if (selectedOption) {
                        const selectedName = selectedOption.RequestedByName;
                        selectedNames.push(selectedName);
                    }
                    if (selectedIdOption) {
                        const selectedName = selectedOption.RequestedBy;
                        selectedIds.push(selectedName);
                    }
                });
                console.log("Selected Names:", selectedNames.join(", "));
                if (selectedNames.length > 2) {
                    reqbyNames.value = selectedNames.slice(0, 2).join(", ") + ", ...";
                } else {
                    reqbyNames.value = selectedNames.join(", ");
                }
                if (selectedIds.length > 0) {
                    reqbyIds.value = selectedIds.join(", ");
                }
                // alert(issuebyNames.value)
                // console.log(ToStoreIds.value);

            }
        }

        function updatedrecby() {
            debugger;
            recbyIds.value = '';
            const selectedValues = ObjServiceType.value.recby;

            if (selectedValues && Array.isArray(selectedValues)) {
                const selectedNames: any = [];
                const selectedIds: any = []
                selectedValues.forEach((selectedValue) => {
                    const selectedOption = options.value.recbyarray.find(
                        (option) => option.value === selectedValue
                    );
                    const selectedIdOption = options.value.reqbyarray.find(
                        (option) => option.value === selectedValue
                    );
                    if (selectedOption) {
                        const selectedName = selectedOption.ReceivedByName;
                        selectedNames.push(selectedName);
                    }
                    if (selectedIdOption) {
                        const selectedName = selectedOption.ReceivedBy;
                        selectedIds.push(selectedName);
                    }
                });
                console.log("Selected Names:", selectedNames.join(", "));
                if (selectedNames.length > 2) {
                    recbyNames.value = selectedNames.slice(0, 2).join(", ") + ", ...";
                } else {
                    recbyNames.value = selectedNames.join(", ");
                }
                if (selectedIds.length > 0) {
                    recbyIds.value = selectedIds.join(", ");
                }
                // alert(issuebyNames.value)
                // console.log(ToStoreIds.value);

            }
        }


        watch(
            () => props.removechiptype,
            (newVal) => {
                if (newVal == 1) {
                    debugger;
                    ObjServiceType.value.issueid = ''
                } else if (newVal == 2) {
                    ObjServiceType.value.requestid = ''
                } else if (newVal == 3) {
                    ObjServiceType.value.tostore = ''
                    ToStoreNames.value = ''
                    ToStoreIds.value = ''
                } else if (newVal == 4) {
                    ObjServiceType.value.issueid = ''
                    ObjServiceType.value.requestid = ''
                    ObjServiceType.value.tostore = ''
                    ToStoreNames.value = ''
                    ToStoreIds.value = ''
                }

            }
        );
        watch(
            () => props.dataList,
            (newVal) => {
            //    alert('d')
                const uniqueItems = [...new Map(props.dataList.map((item:any) => [item['IssuedBy'], item])).values()];
                options.value.issuearray = uniqueItems.map(item => ({
                    name: item['IssuedByName'], // Display name in the dropdown

                    value: item['IssuedBy'] // Unique identifier (or another unique value)
                }));


                const uniqueItems2 = [...new Map(props.dataList.map((item:any) => [item['ReceivedBy'], item])).values()];
                options.value.recarray = uniqueItems2.map(item => ({
                    name: item['ReceivedByName'], // Display name in the dropdown
                    value: item['ReceivedBy'] // Unique identifier (or another unique value)
                }));
                
                const uniqueItems3 = [...new Map(props.dataList.map((item:any) => [item['RequestedBy'], item])).values()];
                options.value.reqby = uniqueItems3.map(item => ({
                    name: item['RequestedByName'], // Display name in the dropdown
                    value: item['RequestedBy'] // Unique identifier (or another unique value)
                }));
                

             

            }
        );

        return {
            updatedrecby,
            updatedreqby,

            updatedissueby,
            ObjServiceType,
            options,
            updatedSupplier
        }
    }

})
</script>

<style lang="scss" scoped></style>